import * as React from 'react';
import Paper from '@mui/material/Paper';
import { useParams } from 'react-router-dom';
import { EditorSwitch, useEditorChoice } from '../../features/stackBuilder';
import SequenceBuilder from './SequenceBuilder/SequenceBuilder';
import SequenceDetails from './SequenceDetails/SequenceDetails';

/**
 * The one place the classic and new sequence editors meet. Each person's Classic/New choice picks
 * which one renders; neither editor imports the other. Retiring the classic editor means deleting
 * SequenceDetails/ and rendering SequenceBuilder directly here.
 *
 * The classic screen has no room for the switch in its own header, and is left untouched, so the
 * switch floats over its bottom-left corner instead.
 */
export default function SequenceEditorRoute() {
  const [choice] = useEditorChoice('sequence');
  const { sequenceId } = useParams();
  // Remount on a new id, so neither editor carries one sequence's state into another.
  if (choice === 'stack') return <SequenceBuilder key={sequenceId ?? 'create'} />;
  return (
    <>
      <SequenceDetails key={sequenceId ?? 'create'} />
      <Paper
        elevation={6}
        sx={{
          position: 'fixed',
          left: 16,
          bottom: 16,
          zIndex: (theme) => theme.zIndex.speedDial,
          p: 0.5,
          borderRadius: 2,
        }}
      >
        <EditorSwitch screen='sequence' confirmLoss />
      </Paper>
    </>
  );
}
